
import React, { useEffect, useState, useRef } from 'react'
import { InputBox, FormButton, Switch, AutoCompleteBox, AutoCompleteBoxWithLabel, DateBox, MonthBox, YearBox, SelectInputBox } from "../commoncomponents/InputBox";
import { useAuth } from '../../context/auth';
import { Table } from '../commoncomponents/Table';
//loder
import BlurLoader from "../Loder/BlurLoader";
//react toast 
import { toast } from 'react-toastify';
//common Data
import { API_SERVER, handleDownloadExcel, initializeFilterData } from '../../Utils';
//services
import { post } from '../../apiservices/service';
import { getCommonData, getMasterData } from '../../apiservices/CommonServices';
import { Token, currentYear, dateFormate, number, numberwithDot } from '../Common/Common';

function YearToDateSalaryReport() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();
    //token Data
    //const TokenData = {
    //    AuthToken: process.env.REACT_APP_SECRET_KEY,
    //    LoginToken: user.loginsessionID,
    //    UserID: user.userID,
    //    CompanyID: user.companyID
    //}
    const TokenData = Token()
    //initial state
    const [recipe, setRecipe] = useState({
        //  loanTypeID: "0",
        branch: '',
        employee: '',
        //   company: '',
        state: '',
        year: '',
    })

    const [loading, setLoading] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [branchAllData, setBranchAllData] = useState([])
    const [companyAllData, setCompanyAllData] = useState([])
    const [employeeAllData, setEmployeeAllData] = useState([])
    const [stateAllData, setStateAllData] = useState([])
    const [errors, setErrors] = useState({});
    const [result, setResult] = useState({});
    const [showTable, setShowTable] = useState(false)


    const [yearData, setYearData] = useState([]);
    const [monthData, setMonthData] = useState([]);

    //Get Month Data
    const GetMonthData = () => {
        setMonthData([])
        let temp = {
            Type: "GetMonth",
            Prefix: '',

        }
        setLoading(true)
        getMasterData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setMonthData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setMonthData(data)
                }
            }
        });
    };


    //Get Year Data
    const GetYearData = () => {
        setYearData([])
        let temp = {
            Type: "GetFinancialYear",
            Prefix: '',

        }
        setLoading(true)
        getMasterData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setYearData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setYearData(data)
                }
            }
        });
    };


    //Get company Data for AutoComplete
    const GetCompanyData = (value) => {
        setCompanyAllData([])
        let temp = {
            Type: "GetCompany",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        //  setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setCompanyAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setCompanyAllData(data)
                }
            }
        });
    }


    //Get branch Data for AutoComplete
    const GetBranchData = (value) => {
        setBranchAllData([])
        let temp = {
            Type: "GetBranch",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        //   setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setBranchAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setBranchAllData(data)
                }
            }
        });
    }

    //Get employee Data for AutoComplete
    const GetEmployeeData = (value) => {
        setEmployeeAllData([])
        let temp = {
            Type: "GetEmployee",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        //   setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setEmployeeAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setEmployeeAllData(data)
                }
            }
        });
    }

    //Get employee Data for AutoComplete
    const GetStateData = (value) => {
        setStateAllData([])
        let temp = {
            Type: "GetState",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        //   setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setStateAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setStateAllData(data)
                }
            }
        });
    }

    const handleSubmit = (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }

        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/Report/ShowYearToDateSalaryReport`, { ...TokenData, ...recipe,PageIndex: PageIndex.toString(),/* year: recipe.year ? currentYear(recipe.year) : '', month: recipe.month ? `${(recipe.month).getMonth() + 1}` : '',*/ }, (res) => {
                if (res && res.Status) {
                    if (res.Status === "ERROR") {
                        toast.error(res.Message)
                        setLoading(false)
                        setResult({ ...res })
                        setShowTable(true)
                    } else if (res.Status === "EXPIRED") {
                        toast.error(res.Message)
                        sessionExpired()
                    } else if (res.Status === "UNAUTHORIZED") {
                        toast.error(res.Message);
                        setLoading(false);
                    } else  {
                        setLoading(false)
                        //toast.success(res.Message)
                        setResult({ ...res })
                        setShowTable(true)
                        //getFormData()
                        // handleClear()
                    }
                }
            });
        }
    }


    const handleChange1 = (event, value) => {
        //getFormData(value);
        handleSubmit(value);
    };
    // console.log(currentYear(recipe.year))

    useEffect(() => {
        inputrefs.current['txtEmployee'].focus();
        // inputrefs.current['txtCompany'].focus();
        document.title = 'Viva HRMS : Year To Date Salary Report';
        // GetCompanyData();
        GetBranchData();
        GetEmployeeData();
        GetStateData();
        GetMonthData();
        GetYearData();
    }, [])

    //useEffect(() => {

    //})

    //Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            { field: "year", msg: 'Please Select Year.' },
        ]

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0 || recipe[item.field] === '') {

                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });

        return isValid;
    }

    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({
            ...recipe,
            branch: '',
             employee: '',
            // company: '',
            state: '',
            year: '',
        }))
        setErrors({})
        setShowTable(false);
    }

    let CompanyData = []
    for (let i = 0; i < companyAllData.length; i++) {
        let mydata = companyAllData[i]?.values
        CompanyData.push(mydata)
    };

    let BranchData = []
    for (let i = 0; i < branchAllData.length; i++) {
        let mydata = branchAllData[i]?.values
        BranchData.push(mydata)
    };


    let EmployeeData = []
    for (let i = 0; i < employeeAllData.length; i++) {
        let mydata = employeeAllData[i]?.values
        EmployeeData.push(mydata)
    };

    let StateData = []
    for (let i = 0; i < stateAllData.length; i++) {
        let mydata = stateAllData[i]?.values
        StateData.push(mydata)
    };

    //Start Export functionality
    let ExportRequest = {
        ...TokenData,
        ...recipe,
        Type: 'E',
        PageIndex: '1',
        //month: recipe.month ? `${(recipe.month).getMonth() + 1}` : '',
        //year: recipe.year ? currentYear(recipe.year) : '',

    }
    //End Export functionality


    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">Year To Date Salary Report</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtBranch'].focus() };
                            }}
                            label='Employee'
                            placeholder="Employee"
                            maxLength='100'
                            options={EmployeeData}
                            id='txtEmployee'
                            key='txtEmployee'
                            error={errors.employee}
                            inputValue={recipe.employee ? recipe.employee : ''}
                            onInputChange={(event, newInputValue) => {
                                GetEmployeeData(newInputValue)
                                HandleChange('employee', newInputValue)
                            }}
                        />

                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtState'].focus() };
                            }}
                            label='Branch'
                            placeholder="Branch"
                            maxLength='100'
                            options={BranchData}
                            id='txtBranch'
                            key='txtBranch'
                            error={errors.branch}
                            inputValue={recipe.branch ? recipe.branch : ''}
                            onInputChange={(event, newInputValue) => {
                                GetBranchData(newInputValue)
                                HandleChange('branch', newInputValue)
                            }}
                        />
                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtYear'].focus() };
                            }}
                            label='State'
                            placeholder="State"
                            maxLength='100'
                            options={StateData}
                            id='txtState'
                            key='txtState'
                            error={errors.state}
                            inputValue={recipe.state ? recipe.state : ''}
                            onInputChange={(event, newInputValue) => {
                                GetStateData(newInputValue)
                                HandleChange('state', newInputValue)
                            }}
                        />
                        <SelectInputBox
                            label='Year'
                            inputrefs={inputrefs}
                            id="txtYear"
                            value={recipe.year}
                            required
                            error={errors.year}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { handleSubmit() };
                            }}
                            onChange={(e) => HandleChange('year', e.target.value)}
                            children={<>
                                <option value="">--Year--</option>
                                {yearData.map((opt, index) => <option key={index} value={opt.id} >{opt.name}</option>)}
                            </>}
                        />

                        <FormButton
                            saveButtonIcon='fa-search'
                            SaveText='Search'
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(API_SERVER + 'api/Report/ShowYearToDateSalaryReport', ExportRequest, 'Year To Date Salary Report', sessionExpired)}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>

            {showTable &&
                <Table
                    Filter={false}
                    Action={false}
                    Token={TokenData}
                PageName='YearToDateSalaryReport'
                  
                    tableData={result}
                    loading={loading}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                />
            }
            {loading && < BlurLoader />}
        </>
    )
}

export default YearToDateSalaryReport
